module.exports = __webpack_public_path__ + "static/media/Smile_Banner.63fffac7.png";